import { HttpMethodEnum } from "../../data/models/HttpMethodEnum";
import { BaseApi } from "../../utils/BaseApi";
import { PaymentDataModel } from "../models/Soul/PaymentDataModel";
import { SoulAuthSession } from "../models/Soul/SoulAuthSession";
import {
  SoulDataModel,
  UpdateSoulInfoPayload,
} from "../models/Soul/SoulDataModel";
import { SoulLoginParams } from "../models/Soul/SoulLoginParams";
import { SoulSessionModel } from "../models/Soul/SoulSessionModel";

export class SoulApi extends BaseApi {
  private static instance: SoulApi;

  public static get(): SoulApi {
    if (!this.instance) {
      this.instance = new SoulApi();
    }
    return this.instance;
  }

  public soulLogin = BaseApi.createEndpoint<null, SoulLoginParams>(
    HttpMethodEnum.POST,
    "/soul/login"
  );

  public soulInfo = BaseApi.createEndpoint<SoulDataModel, null>(
    HttpMethodEnum.GET,
    "/soul"
  );

  public allSoulsInfo = BaseApi.createEndpoint<SoulDataModel[], null>(
    HttpMethodEnum.GET,
    "/soul/all"
  );

  public allPaymentsInfo = BaseApi.createEndpoint<PaymentDataModel[], null>(
    HttpMethodEnum.GET,
    "/soul/allPayments"
  );

  public updateSoulInfo = BaseApi.createEndpoint<
    SoulDataModel,
    UpdateSoulInfoPayload
  >(HttpMethodEnum.PUT, "/soul");

  public soulAuth = BaseApi.createEndpoint<null, SoulSessionModel>(
    HttpMethodEnum.POST,
    "/soul/auth"
  );

  public soulCheckAuth = BaseApi.createEndpoint<
    SoulAuthSession,
    SoulSessionModel
  >(HttpMethodEnum.POST, "/soul/check-auth");
}

export const soulApi = SoulApi.get();
